import { FacebookSearchResultsPage } from "../../Components/FacebookSearchResultsPage"
import { FacebookSearchNavbar } from "../../Components/FacebookSearchNavbar"

export const FacebookSearchContainer = () => {
    return(
        <div style={{display: 'flex'}}>
            <FacebookSearchNavbar/>
            <FacebookSearchResultsPage/>
        </div>
    )
}